import e from "@dialpad/dialtone-tokens/layered/themes/tokens-kiln-colors.css?inline";
//#region themes/kiln.js
var t = {
	brand: {
		css: e,
		name: "kiln"
	},
	material: { name: "graphite" }
};
//#endregion
export { t as default };
